if (!customElements.get('vr-footer')) {
  customElements.define('vr-footer', class extends HTMLElement {
    connectedCallback() {
      this.media = matchMedia('(min-width: 769px)');
      this.setMenus = () => this.querySelectorAll('[data-footer-menu]').forEach(menu => { menu.open = this.media.matches; });
      this.media.addEventListener('change', this.setMenus);
      this.setMenus();
    }
    disconnectedCallback() { this.media?.removeEventListener('change', this.setMenus); }
  });
}

